import { motion } from 'framer-motion';
import { Shield, Lock, Eye, Database } from 'lucide-react';

const privacyFeatures = [
  { icon: Shield, text: 'End-to-end encryption' },
  { icon: Lock, text: 'Zero data sharing' },
  { icon: Eye, text: 'You control your data' },
  { icon: Database, text: 'Secure cloud storage' },
];

export const PrivacyBanner = () => {
  return (
    <section className="relative py-20 overflow-hidden border-y border-border">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/[0.04] to-transparent dark:via-primary/[0.08]" />
      <div className="container relative mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 tracking-tight">
            <span className="text-foreground">Your Privacy is </span>
            <span className="bg-gradient-to-r from-primary via-violet-500 to-fuchsia-500 bg-clip-text text-transparent">
              Non-Negotiable
            </span>
          </h2>
          <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
            Built with enterprise-grade security. Your career data stays
            private, always.
          </p>

          <div className="flex flex-wrap justify-center gap-6 max-w-3xl mx-auto">
            {privacyFeatures.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.96 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.08 }}
                className="flex items-center gap-2 px-4 py-2.5 bg-background/80 backdrop-blur-sm rounded-full border-2 border-primary/20 hover:border-primary/40 transition-colors shadow-sm"
              >
                <feature.icon className="w-5 h-5 text-primary" />
                <span className="text-sm font-medium">{feature.text}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

